import { TMessage } from './types/entity';

let counter = 0;

export const createMessage = (message: Omit<TMessage, 'id'>): TMessage => ({
  ...message,
  id: String((counter += 1)),
});
